import '../../styles/admin.css';
import { NavLink } from 'react-router-dom';

export default function CommercialWelcome() {
  return (
    <div>
      <h1>Bienvenue</h1>
      <p className="muted">Accès commercial: gérez vos catégories, produits, réalisations et événements.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, marginTop: 12 }}>
        <Card to="/admin/categories" title="Catégories" />
        <Card to="/admin/products" title="Produits" />
        <Card to="/admin/projects" title="Réalisations" />
        <Card to="/admin/events" title="Événements" />
        <Card to="/admin/messages" title="Messages" />
        <Card to="/admin/slides" title="Slides accueil" />
      </div>
    </div>
  );
}

function Card({ to, title }) {
  return (
    <NavLink to={to} className={() => ''}>
      <div style={{ border: '1px solid #eef0f2', borderRadius: 12, padding: 14, background: '#fff', boxShadow: '0 8px 22px rgba(15,23,42,0.06)' }}>
        <div style={{ fontWeight: 700 }}>{title}</div>
        <div className="muted" style={{ fontSize: 12 }}>Accéder</div>
      </div>
    </NavLink>
  );
}
